export const REQUEST_STATES = [
  'draft',
  'transmitting',
  'pending',
  'surfaced',
  'observed',
  'accepted',
  'active',
  'paused',
  'rejected',
  'expired',
  'blocked',
  'failed',
] as const;

export const PENDING_REQUEST_STATES = ['transmitting', 'pending', 'surfaced', 'observed'] as const;

export const PRESENCE_PRESETS = [
  'very_botherable',
  'building',
  'slow_replies',
  'sleeping',
] as const;

export const URGENCY_LEVELS = ['casual', 'normal', 'important'] as const;
export const IDENTITY_MODES = ['custom', 'anonymous', 'generated'] as const;

export const DEFAULT_INTENTS = [
  'Just saying hi',
  'Ask something',
  'Talk about something',
  'Show you something',
  'Send chaos',
  'Give feedback',
  'Other',
] as const;

export const MAX_MESSAGE_LENGTH = 10_000;
export const MAX_ALIAS_LENGTH = 40;
export const API_VERSION = 1;

export const SUPPORTED_ATTACHMENT_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'video/mp4',
  'audio/wav',
  'application/pdf',
  'text/plain',
] as const;
export const MAX_ATTACHMENTS_PER_MESSAGE = 4;
export const MAX_ATTACHMENT_TOTAL_BYTES = 32 * 1024 * 1024;
export const ATTACHMENT_MAX_BYTES = {
  'image/png': 8 * 1024 * 1024,
  'image/jpeg': 8 * 1024 * 1024,
  'image/webp': 8 * 1024 * 1024,
  'video/mp4': 20 * 1024 * 1024,
  'audio/wav': 6 * 1024 * 1024,
  'application/pdf': 10 * 1024 * 1024,
  'text/plain': 1024 * 1024,
} as const;
